<template>
    <div class="relative text-text-l flex font-medium" data-component="AmsSort">
        <select class="absolute left-0 w-full h-full opacity-0 cursor-pointer" @click="trackClick" @change="onChange">
            <option
                v-for="(option, index) in options"
                :key="option.value + index"
                :value="option.value"
                :selected="option.value === modelValue"
            >
                {{ option.label }}
            </option>
        </select>
        <ms-sort class="w-24 h-24 mr-8" /> Sortierung
    </div>
</template>

<script lang="ts" setup>
import { MsSort } from '@sunrise/icons'
import { TrackingParameter, createTealiumTracking, trackLink } from '@sunrise/tracking'
import { PropType } from 'vue'
import { DropdownOption } from '../AmsDropdown/AmsDropdown.interface'

const props = defineProps({
    modelValue: String,
    options: {
        type: Array as PropType<DropdownOption[]>,
        required: true,
    },
    trackingData: Object as PropType<TrackingParameter>,
})

const emit = defineEmits<{
    (e: 'update:modelValue', event: string): void
}>()

const onChange = (event: Event) => {
    const select = event.target as HTMLSelectElement
    emit('update:modelValue', select.value)
}

const trackClick = (e: MouseEvent) => {
    if (!props.trackingData) return
    // We need to remove the reference to the object by destructuring because it
    // gets mutated otherwise and the next tracking will contain unwanted data
    const tealiumTrackingData = createTealiumTracking({ ...props.trackingData })
    trackLink(e, e.currentTarget as HTMLAnchorElement, [tealiumTrackingData])
}
</script>
